export default __webpack_public_path__ + "static/media/element_47.34900485.webp";